import { render, staticRenderFns } from "./FeeDialog.vue?vue&type=template&id=389a852b&scoped=true&"
import script from "./FeeDialog.vue?vue&type=script&lang=js&"
export * from "./FeeDialog.vue?vue&type=script&lang=js&"
import style0 from "./FeeDialog.vue?vue&type=style&index=0&id=389a852b&prod&lang=less&scoped=true&"
import style1 from "./FeeDialog.vue?vue&type=style&index=1&id=389a852b&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389a852b",
  null
  
)

export default component.exports